<!--
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="column" fxLayoutAlign="center center">
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    *ngIf="isCustomer && !isUserConsumer()"
    routerLink="/business-list"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
    class="ws-outline-none"
  >
    <div class="nvc-active"></div>
    <p i18n>Home</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    *ngIf="!isCustomer"
    routerLink="/homePage"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
    class="ws-outline-none"
  >
    <div class="nvc-active"></div>
    <p i18n>Home</p>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="notranslate"
    routerLink="/user/profile"
    routerLinkActive="active"
    (click)="closeNav()"
    *ngIf="isLoggedInUser"
  >
    <div class="nvc-active"></div>
    <p i18n>My Profile</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="ws-outline-none"
    routerLink="/notifications"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
    *ngIf="isLoggedInUser && !isCustomer"
  >
    <div class="nvc-active"></div>
    <p i18n>Notifications</p>

    <span class="notificationCountText" *ngIf="storesService.notificationCount"
      >({{ storesService.notificationCount }})</span
    >
  </div>
  <div
    *ngIf="isLoggedInUser && isCustomer && isCheckoutEnabled"
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/myorders/consumer-cart"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n>
      Cart
      <span>( {{ slotService.cartCount ? slotService.cartCount : 0 }} )</span>
    </p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/stores"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n *ngIf="isLoggedInUser && isCatalog && !isCustomer">
      {{ getStoresText() }}
    </p>
  </div>
  <!-- <p routerLink='/offer/favourites' routerLinkActive="active" >Favourites</p> -->
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/appointments"
    *ngIf="isCustomer && isLoggedInUser && isAppointment"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n>My Bookings</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/appointments"
    *ngIf="!isCustomer && isLoggedInUser && !isSupplier && isAppointment"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav('appointments')"
  >
    <div class="nvc-active"></div>
    <p i18n>My Appointments</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/quotations"
    *ngIf="!isCustomer && isLoggedInUser && isQuotation"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav('quotations')"
  >
    <div class="nvc-active"></div>
    <p i18n>Quotations</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/myorders"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active" *ngIf="!router.url.includes('consumer-cart')"></div>
    <p i18n *ngIf="isLoggedInUser">My Orders</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/mywishlist"
    *ngIf="showWishList"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n>My Wishlist</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/myaddresses"
    *ngIf="!isRetailer()"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n *ngIf="isLoggedInUser && isCheckoutEnabled">My Addresses</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/privacy-policy"
    *ngIf="!isRetailer()"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n *ngIf="isLoggedInUser">Privacy Policy</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    routerLink="/my-company"
    routerLinkActive="active"
    class="notranslate"
    (click)="closeNav()"
    *ngIf="!isCustomer"
  >
    <div class="nvc-active"></div>
    <p i18n *ngIf="isLoggedInUser">My Company</p>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="notranslate"
    routerLink="/auth/change-password"
    routerLinkActive="active"
    *ngIf="isLoggedInUser"
    (click)="closeNav()"
  >
    <div class="nvc-active"></div>
    <p i18n>Change Password</p>
  </div>
</div>
